// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsergroupAddOutlinedSvg from "@ant-design/icons-svg/es/asn/UsergroupAddOutlined";
import AntdIcon from '../components/AntdIcon';

var UsergroupAddOutlined = function UsergroupAddOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupAddOutlinedSvg
  }));
};

UsergroupAddOutlined.displayName = 'UsergroupAddOutlined';
export default React.forwardRef(UsergroupAddOutlined);